import {
  reactExtension,
  Banner,
  BlockStack,
  Checkbox,
  Image,
  Text,
  useApi,
  useApplyAttributeChange,
  useInstructions,
  useTranslate, useSettings,
} from "@shopify/ui-extensions-react/checkout";

// 1. Choose an extension target
export default reactExtension("purchase.checkout.block.render", () => (
  <Extension />
));

function Extension() {
  const translate = useTranslate();
  const { extension } = useApi();
  const instructions = useInstructions();
  const applyAttributeChange = useApplyAttributeChange();

  const {
    image_url
  } = useSettings();

  // 2. Check instructions for feature availability, see https://shopify.dev/docs/api/checkout-ui-extensions/apis/cart-instructions for details
  // if (!instructions.attributes.canUpdateAttributes) {
  //   // For checkouts such as draft order invoices, cart attributes may not be allowed
  //   // Consider rendering a fallback UI or nothing at all, if the feature is unavailable
  //   return (
  //     <Banner title="scsbiz-image" status="warning">
  //       {translate("attributeChangesAreNotSupported")}
  //     </Banner>
  //   );
  // }

  // 3. Render a UI
  return (
    <BlockStack border={"none"} padding={"none"}>
      <Image source={image_url as string}></Image>
        {/*{translate("welcome", {
          target: <Text emphasis="italic">{extension.target}</Text>,
        })}*/}

      {/*<Checkbox onChange={onCheckboxChange}>
        {translate("iWouldLikeAFreeGiftWithMyOrder")}
      </Checkbox>*/}
    </BlockStack>
  );

  async function onCheckboxChange(isChecked) {
    // 4. Call the API to modify checkout
    const result = await applyAttributeChange({
      key: "requestedFreeGift",
      type: "updateAttribute",
      value: isChecked ? "yes" : "no",
    });
    console.log("applyAttributeChange result", result);
  }
}
